const firebaseConfig = {
  apiKey: "AIzaSyCeQ6TsObuVVn7IzU097UUhi6HRFWlJAEI",
  authDomain: "cardekho-6086f.firebaseapp.com",
  projectId: "cardekho-6086f",
  storageBucket: "cardekho-6086f.appspot.com",
  messagingSenderId: "663126972049",
  appId: "1:663126972049:web:85be583a98e16fd10dd130"
  };

export default firebaseConfig;